import { tv, type VariantProps } from 'tailwind-variants';
export type OrGenericContentVariants = VariantProps<
  typeof orGenericContentVariants
>;

export const orGenericContentVariants = tv({
  base: '',
  slots: {},
  variants: {
    top_spacing: {
      xs: 'pt-xs',
      sm: 'pt-sm',
      md: 'pt-md',
      lg: 'pt-lg',
      xl: 'pt-xl',
    },
    bottom_spacing: {
      xs: 'pb-xs',
      sm: 'pb-sm',
      md: 'pb-md',
      lg: 'pb-lg',
      xl: 'pb-xl',
    },
  },
  compoundVariants: [],
});
